import { FC } from "react"

import { useTranslation } from "react-i18next"

import { DropdownMenu } from "components/inputs/DropdownMenu"
import { SectionCard } from "components/settings/SectionCard"

import { PROVIDER_VALUES } from "./constants"
import { FormState, SetFormField } from "./types"

interface ProviderSectionProps {
  form: FormState
  saving: boolean
  onFieldChange: SetFormField
}

export const ProviderSection: FC<ProviderSectionProps> = ({ form, saving, onFieldChange }) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  const options = PROVIDER_VALUES.map((value) => ({
    value,
    name: t(`settings.liveChat.provider.options.${value === "" ? "unset" : value}`)
  }))

  return (
    <SectionCard title={t("settings.liveChat.provider.title")} description={t("settings.liveChat.provider.description")}>
      <DropdownMenu
        title={t("settings.liveChat.provider.label")}
        options={options}
        value={form.provider}
        onChange={(e: { target: { value: string } }) => onFieldChange("provider", e.target.value as FormState["provider"])}
        hideEmptyOption
        disableEmptyOption
        disabled={saving}
      />
      {form.provider === "" && (
        <p className="text-xs text-gray-500 dark:text-gray-400">{t("settings.liveChat.provider.hintUnconfigured")}</p>
      )}
      {form.provider === "none" && (
        <p className="text-xs text-gray-500 dark:text-gray-400">{t("settings.liveChat.provider.hintNone")}</p>
      )}
    </SectionCard>
  )
}
